'use client';

import { createParsedEventHandler } from '@/hooks/socket/socket.helpers';
import { useSocketEvent } from '@/hooks/socket/useSocketEvent';
import { resolveDepositErrorModal } from '@/modals/modules/balances/+DepositResultModal/components/consts/paytechToDepositErrorCode';
import openModal from '@/modals/utils/openModal';
import { useAppSelector } from '@/redux/hooks';
import { PaymentTransactionFailedMessageSchema } from './paymentTransaction.schema';

export function usePaymentTransactionSocket() {
  const userSession = useAppSelector(state => state.user.userSession);
  const isSessionActive = Boolean(userSession);

  const handlePaymentTransactionFailed = createParsedEventHandler(
    PaymentTransactionFailedMessageSchema,
    (data) => {
      // A `payment-transaction.failed` event always means the deposit failed, so
      // fall back to the generic failure modal when no specific code is sent.
      const resultCode = resolveDepositErrorModal(data.internalCode, { fallbackOnMissing: 'PAYMENT_FAILED' });

      if (resultCode) {
        openModal('deposit-result', { resultCode, activeOrderId: data.orderId });
      }
    },
  );

  useSocketEvent(
    'payment-transaction.failed',
    handlePaymentTransactionFailed,
    isSessionActive,
  );
}
